var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F9F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4158_34532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 30.0011C50 41.0513 41.0492 50.0022 29.9989 50.0022C18.9487 50.0022 10 41.0492 10 30.0011C10 18.953 18.9508 10 30.0011 10C41.0513 10 50.0022 18.9508 50.0022 30.0011M48.0914 29.9837C48.0914 20.0092 39.9995 11.9173 30.0249 11.9173C20.0504 11.9173 11.9585 20.0092 11.9585 29.9837C11.9585 39.9583 20.0504 48.0502 30.0249 48.0502C39.9995 48.0502 48.0914 39.9583 48.0914 29.9837Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4158_34532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 25.2213C28 25.6518 27.6058 26 27.1184 26H19.8816C19.3942 26 19 25.6518 19 25.2213V24.7787C19 24.3482 19.3942 24 19.8816 24H27.1184C27.6058 24 28 24.3482 28 24.7787V25.2213Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5691 36.9178C28.2196 38.4315 31.3074 38.4919 34.8344 37.0864C35.2883 36.9011 35.8026 37.0635 36.0712 37.4695C36.3086 37.8297 36.4168 38.0775 36.4023 38.2233C36.3252 38.8687 35.8713 39.4142 35.2259 39.6287C30.9014 41.0737 27.2827 40.8967 24.3781 39.0977C21.2966 37.6319 19.1854 34.6899 18.0548 30.2738C17.8862 29.6138 18.1006 28.9371 18.6003 28.5228C18.7086 28.4312 18.9834 28.3916 19.4061 28.3916C19.8975 28.3999 20.3118 28.7456 20.4055 29.2224C21.1363 32.9493 22.8561 35.5145 25.5691 36.9199V36.9178Z",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 25.5,
    r: 2.75,
    stroke: "#1E1E1D",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4158_34532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4158_34532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1139,
    height: 19.5946,
    fill: "white",
    transform: "translate(18 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilly);
export default __webpack_public_path__ + "static/media/silly.013a8cfdcf5764ecd90c296885e43a7c.svg";
export { ForwardRef as ReactComponent };